export const PURCHASE_UNIT_OPTIONS = [
  "Balde",
  "Bidón",
  "Bolsa",
  "Botella",
  "Caja",
  "Frasco",
  "Kilogramo",
  "Pack",
  "Pieza",
  "Bote",
  "Unidad",
  "Lata",
];

export function isCanonicalPurchaseUnit(value) {
  return PURCHASE_UNIT_OPTIONS.includes(String(value ?? "").trim());
}
